export default __webpack_public_path__ + "static/media/fluidsim_demo_image.5efc0c5a.gif";